import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
const swal = require('sweetalert');
import { environment } from '../../../../environments/environment';
import { LoginService } from 'src/app/services/login/login.service';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { RegisterUserService } from './../../../services/registerUser/register-user.service';
import { UserMerchantData } from "./../../../services/Common/common-function.service";

import { FormControl, Validators } from "@angular/forms";
@Component({
  selector: 'app-virtual-terminal-access',
  templateUrl: './virtual-terminal-access.component.html',
  styleUrls: ['./virtual-terminal-access.component.scss']
})
export class VirtualTerminalAccessComponent implements OnInit {
  IsLocationAllow: boolean = false;
  GeoLocation: any;
  devicetype: any;
  CurrentIp = localStorage.getItem('ipaddress');;
  key: any;
  virtualterminal: any;
  isloginSuccess: any = true;
  isloginfailed: boolean = false;
  isPasswordExpired: boolean = false;
  isValidMerchant: boolean = true;
  isMerchantNotActive: boolean = false;
  isAccountApproved: boolean = false;
  isAccountRejected: boolean = false;
  isAccountVerificationPending: boolean = false;
  isAccountOnHold: boolean = false;
  isAccountCancled: boolean = false;
  isAccountDeclined: boolean = false;
  isEmailConfirmationPending: boolean = false;
  email = new FormControl("", [Validators.required, Validators.email]);
  password = new FormControl("", [Validators.required]);

  constructor(private router: ActivatedRoute,
    private route: Router,
    private service: LoginService,


    private commonfunction: CommonFunctionService,
    private registerUserService: RegisterUserService

  ) { }

  ngOnInit() {
    this.key = this.router.snapshot.queryParamMap.get("token");
    this.virtualterminal = localStorage.getItem('TerminalAccess')
    console.log(this.virtualterminal);
    this.getUserLocation();
  }

  virtualTerminalAccess() {
    this.getBrowserName();
    let form = { keyVal: "", IpAddress: "", DeviceType: "", GeoLocation: "", AppVersion: "", DeviceId: "" };
    form.keyVal = this.key;
    // form.IpAddress=this.CurrentIp;
    form.IpAddress = "";
    form.DeviceType = this.devicetype;
    form.GeoLocation = this.GeoLocation;
    form.AppVersion = "Vpos"


    this.isloginSuccess = this.service.virtualTerminalAccess(form).subscribe(result => {

      if (environment.clientsidelogflag == 0) {
        console.log("login service - promise response data:  ", result);
      }
      // 0401
      if (result['Code'] == "0401") {
        this.isloginfailed = true;
      }
      else {
        localStorage.setItem("VirtualPOSToken", JSON.stringify(result));
      }

      let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
      console.log("testing", merchantdata);

      let dateString = merchantdata.PasswordExpiryDate;
      var datearray = dateString.split("-");
      var newdate = datearray[1] + '-' + datearray[0] + '-' + datearray[2];
      let passwordExpiryDate = new Date(newdate);
      let currentdate = new Date();
      let loggedInUserEmail = this.commonfunction.getEmail();

      if (merchantdata.TempPass == "True" || merchantdata.ConfirmedEmail == "false") {
        if (merchantdata.TempPass == "True") {
          this.isEmailConfirmationPending = false;
          this.route.navigate(["user/changepassword"], {
            queryParams: { email: loggedInUserEmail }
          });
        }
        else if (merchantdata.ConfirmedEmail == "false") {
          this.isEmailConfirmationPending = true;
        }
        else {
          this.isEmailConfirmationPending = false;
        }


      } else if (result == null) {
        this.isloginfailed = true;
        this.isEmailConfirmationPending = false;
      }
      else if (passwordExpiryDate < currentdate) {
        this.isPasswordExpired = true;
        this.route.navigate(["user/changepassword"], {
          queryParams: { email: loggedInUserEmail }
        });
      }
      else if (merchantdata.UserType == "MerchantUser") {
        if (merchantdata.Status == 'Approved') {
          this.isAccountVerificationPending = false;
          this.isEmailConfirmationPending = false;
          this.isAccountApproved = true;
          this.isAccountRejected = false;
          this.route.navigate(["/home"]);
        }
        else if (merchantdata.Status == 'Rejected') {
          this.isAccountApproved = false;
          this.isAccountRejected = true;
          this.isAccountVerificationPending = false;
          this.isEmailConfirmationPending = false;
        }
        else if (merchantdata.Status == 'VerificationPending') {
          this.isAccountApproved = false;
          this.isAccountRejected = false;
          this.isAccountVerificationPending = true;
          this.isEmailConfirmationPending = false;
        }
        else {
          this.isAccountApproved = false;
          this.isAccountRejected = false;
          this.isAccountVerificationPending = false;
          this.isEmailConfirmationPending = false;
        }

      }
      else {
        let resellerno = this.commonfunction.getUserMerchantData().ResellerId;
        this.registerUserService.isValidMerchantKeyId(merchantdata.MerchantKeyId, resellerno).subscribe(result => {
          if (environment.clientsidelogflag == 0) {
            console.log("Merchant info result - ", result);
          }
          if (result.MerchantKeyId > 0 && result.Status <= 5) {
            this.isValidMerchant = true;
            this.isMerchantNotActive = false;
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isMerchantNotActive = false;
            this.isEmailConfirmationPending = false;
            if (environment.clientsidelogflag == 0) {
              console.log("login service - promise response data:  ", result);
            }
            this.route.navigate(["/home"]);

            let permissions = this.commonfunction.getRolesPermissions();
            if (environment.clientsidelogflag == 0) {
              console.log("permissions:  ", permissions);
            }
          }
          else if (result.Status == 9) {
            this.isAccountOnHold = true;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isloginfailed = false;
            this.isEmailConfirmationPending = false;
            this.isMerchantNotActive = false;
          }
          else if (result.Status == 10) {
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = true;
            this.isloginfailed = false;
            this.isEmailConfirmationPending = false;
            this.isMerchantNotActive = false;
          }
          else if (result.Status == 11) {
            this.isAccountOnHold = false;
            this.isAccountCancled = true;
            this.isAccountDeclined = false;
            this.isloginfailed = false;
            this.isEmailConfirmationPending = false;
            this.isMerchantNotActive = false;
          }
          else if (result.Status == 6) {
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isloginfailed = false;
            this.isEmailConfirmationPending = false;
            this.isMerchantNotActive = true;
          }
          // else if (result.Status == 21) {
          //   this.route.navigate(["/home/welcomepayg"]);

          // }

          else if (result.Status >= 12 || result.Status <= 21) {
            this.route.navigate(["/home"]);
            // this.route.navigate(['registration/InprogressPage', { merchantKeyId: result.MerchantKeyId, status: result.Status }]);
          }
          else if (result.MerchantKeyId > 0 && result.Status != 5) {
            this.isValidMerchant = true;
            this.isMerchantNotActive = true;
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isEmailConfirmationPending = false;
          }
          else {
            this.isValidMerchant = false;
            this.isMerchantNotActive = false;
            this.isAccountOnHold = false;
            this.isAccountCancled = false;
            this.isAccountDeclined = false;
            this.isEmailConfirmationPending = false;
          }
        });
      }








    });
  }


  isformvalid() {
    return (this.email.invalid && (this.email.dirty || this.email.touched)) || (this.password.invalid && (this.password.dirty || this.password.touched))
  }


  emailerrors() {
    return this.email.hasError("required")
      ? "User Name is required"
      : this.email.hasError("email") ? "Enter valid Email Address" : "";
  }

  passworderrors() {
    return this.password.hasError("required") ? "Password is required " : "";
  }

  getIP() {
    this.virtualTerminalAccess(); 
  }



  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        this.devicetype = "edge";
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        this.devicetype = "opera";
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        this.devicetype = "chrome";
        return 'chrome';
      case agent.indexOf('trident') > -1:
        this.devicetype = "ie";
        return 'ie';
      case agent.indexOf('firefox') > -1:
        this.devicetype = "firefox";
        return 'firefox';
      case agent.indexOf('safari') > -1:
        this.devicetype = "safari";
        return 'safari';
      default:
        this.devicetype = "other";
        return 'other';
    }
  }




  getUserLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.IsLocationAllow = true;
      this.GeoLocation = "latitude:" + position.coords.latitude + ",longitude:" + position.coords.longitude;
    },
      (error) => {
        this.IsLocationAllow = false;
        let errorMessage = '';
        if (error.PERMISSION_DENIED) {
          errorMessage = `Couldn't get your location Permission denied. \n Please allow the location for access.`;
          swal("Error", errorMessage.toString(), "error");
        }
        else if (error.POSITION_UNAVAILABLE) {
          errorMessage = `Couldn't get your location Position unavailable. \n Please allow the location for access.`;
          swal("Error", errorMessage.toString(), "error");
        }
        else if (error.TIMEOUT) {
          errorMessage = `Couldn't get your location'+'Timed out.`;
          swal("Error", errorMessage.toString(), "Time Out");
        }
        else {
          swal(error.message + `Error: ${error.code}`);
        }
      }, { enableHighAccuracy: true }
    );
  }

}
